import React, { useEffect, useState } from 'react';
import {
  Box,
  Text,
  VStack,
  HStack,
  Table,
  Tbody,
  Tr,
  Td,
  Button,
  Icon,
  Flex,
  Heading,
  Image,
} from '@chakra-ui/react';
import { MdPending, MdPlayCircle } from 'react-icons/md';
import axios from 'axios';
import RelojTiempoReal from 'components/Reloj/reloj';

interface Turno {
  ID: number;
  Folio: string;
  Area: string;
  FechaCreacion: string;
  Estado: string;
  UsuarioAsignado: string | null;
  Notas: string | null;
  FechaAtencion: string | null;
  CajaID: number | null;
}

interface TurnosData {
  proximosTurnos: Turno[];
  turnosEnAtencion: Turno[];
}

const TurnosRealTime = () => {
  const [turnosPendientes, setTurnosPendientes] = useState<string[]>([]);
  const [turnosAtendidos, setTurnosAtendidos] = useState<{ [key: string]: string }>({});
  const [loading, setLoading] = useState(false);

  // Función para obtener los turnos desde la API
  const fetchTurnos = async () => {
    setLoading(true);
    try {
      const response = await axios.get<TurnosData>("http://52.91.130.91:5000/api/turnos");

      if (response.data) {
        const { proximosTurnos, turnosEnAtencion } = response.data;

        // Extraer solo los folios de los turnos pendientes
        const pendientes: string[] = proximosTurnos.map((turno) => turno.Folio);

        // Crear objeto de turnos en atención { Area: Folio }
        const atendidos: { [key: string]: string } = {};
        turnosEnAtencion.forEach((turno) => {
          atendidos[turno.CajaID] = turno.Folio;
        });

        // Actualizar los estados
        setTurnosPendientes(pendientes);
        setTurnosAtendidos(atendidos);
      }
    } catch (error) {
      console.error("Error al obtener los turnos:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTurnos();
    const interval = setInterval(fetchTurnos, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      p={6}
      bg="white"
      color="black"
      borderRadius="lg"
      boxShadow="2xl"
      w="100vw"
      h="100vh"
      mx="auto"
      textAlign="center"
    >
      {/* Cajas de Atención */}
      <HStack
        spacing={75} // Ajustamos el espaciado a un valor más pequeño
        mb={2} // Reducimos el margen inferior para optimizar el diseño
        justifyContent="flex-start" // Alinea los elementos a la izquierda, cerca del logo
        alignItems="center"
        w="100%"
      >
        {/* Logo */}
        <Box>
          {/* Logo */}
          <Image
            src="https://totolac.gob.mx/contenidos/totolac/img/banner_2024_10_7_1728346730.2712.jpg"
            alt="Logo Totolac"
            boxSize="140px"
          />

          {/* Reloj en tiempo real */}
          <RelojTiempoReal />
        </Box>

        {/* Cajas de Atención */}
        <VStack spacing={2} align="center">
          {/* Leyenda Turnos en Atención */}
          <Text fontSize="2xl" fontWeight="bold" color="red.700">
            🔴 Turnos en Atención
          </Text>

          {/* Cajas de atención */}
          <HStack spacing={4} justifyContent="center">
            {Object.entries(turnosAtendidos).map(([CajaID, turno]) => (
              <Box
                key={CajaID}
                p={4}
                bg="red.700"
                color="white"
                borderRadius="lg"
                boxShadow="lg"
                textAlign="center"
                minW="150px"
              >
                <Text fontSize="xl" fontWeight="bold">
                  Caja: {CajaID}
                </Text>
                <Text fontSize="3xl" fontWeight="bold">
                  {turno}
                </Text>
              </Box>
            ))}
          </HStack>
        </VStack>
      </HStack>

      <Box display="flex" width="100%" alignItems="center">
        {/* Turnos Pendientes */}
        <Box
          flex="0.1"
          p={6}
          borderRadius="lg"
          boxShadow="lg"
          textAlign="center"
          border="2px solid black"
          bg="gray.100"
        >
          <HStack justifyContent="center" mb={4}>
            <Icon as={MdPending} boxSize={6} color="red.700" />
            <Text fontSize="2xl" fontWeight="bold" color="red.700">
              Proximos Turnos
            </Text>
          </HStack>
          <Table variant="unstyled" size="md" mt={4}>
            <Tbody>
              {turnosPendientes.map((turno, index) => (
                <Tr key={index}>
                  <Td
                    fontSize="2xl"
                    fontWeight="bold"
                    color="black"
                    textAlign="center"
                    borderBottom="1px solid gray"
                  >
                    {turno}
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>

        {/* Video de YouTube */}
        <Box flex="0.9" p={6} borderRadius="md" textAlign="center">
          {/* <HStack justifyContent="center" mb={4}>
            <Icon as={MdPlayCircle} boxSize={6} color="black" />
            <Text fontSize="2xl" fontWeight="bold" color="black">Información</Text>
          </HStack> */}
          <iframe
            width="100%"
            // height="calc(100vh - 100px)" // Ajusta dinámicamente según la pantalla
            src="https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1&loop=1&playlist=dQw4w9WgXcQ&mute=1"
            title="YouTube video"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
            style={{
              display: 'block',
              objectFit: 'cover', // Asegura que el video cubra el espacio sin distorsionarse
              minHeight: '65vh', // Ocupa toda la pantalla
              width: '100%',
            }}
          ></iframe>
        </Box>
      </Box>

      <Box
        width="100%"
        bg="#A1263D"
        color="white"
        position="fixed"
        bottom="0"
        left="0"
        py={3} // Ajuste de padding para darle mejor apariencia
      >
        <Box textAlign="center" fontSize="sm" color="white.300">
          <Text>© 2024 Ayuntamiento de Totolac.</Text>
        </Box>
      </Box>
    </Box>
  );
};

export default TurnosRealTime;
